// @flow
import type { TISMessage, Target, Car, Plane, UnknownTarget } from '../types';
import { TYPE } from '../constants/targetConstants';

const getType = (target: TISMessage, vehicles: $ReadOnlyArray<string>) => {
    const icao = target.Icao;

    if(vehicles.indexOf(icao) !== -1) {
        return TYPE.car;
    }
    else {
        return TYPE.plane;
    }
};

const createCar = (tisMessage: TISMessage): Car => ({
    ...tisMessage,
    type: TYPE.car
});

const createPlane = (tisMessage: TISMessage): Plane => ({
    ...tisMessage,
    type: TYPE.plane
});

const createUnknown = (tisMessage: TISMessage): UnknownTarget => ({
    ...tisMessage,
    type: TYPE.unknown
});

export default function target(tisMessage: TISMessage, vehicles: $ReadOnlyArray<string>): Target {
    const type = getType(tisMessage, vehicles);

    switch(type) {
        case TYPE.car:
            return createCar(tisMessage);
        case TYPE.plane:
            return createPlane(tisMessage);
        default:
            return createUnknown(tisMessage);
    }
}